import React from 'react';
import { Flex, Text, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import useMedia from '../../Utils/useMedia';

import icon1 from '../../Resources/Images/Icons/icon1.svg';
import icon2 from '../../Resources/Images/Icons/icon2.svg';
import icon3 from '../../Resources/Images/Icons/icon3.svg';
import icon4 from '../../Resources/Images/Icons/icon_notice.svg';

import step1 from '../../Resources/Images/Banners/step1.png';
import step2 from '../../Resources/Images/Banners/step2.png';
import step3 from '../../Resources/Images/Banners/step3.png';
import step4 from '../../Resources/Images/Banners/step4.png';

const Instruction: React.FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useMedia();

  const steps = [
    {
      icon: icon1,
      title: t('upload.step1title'),
      desc: t('upload.step1info'),
      image: step1,
    },
    {
      icon: icon2,
      title: t('upload.step2title'),
      desc: t('upload.step2info'),
      image: step2,
    },
    {
      icon: icon3,
      title: t('upload.step3title'),
      desc: t('upload.step3info'),
      image: step3,
    },
    {
      icon: icon4,
      title: t('upload.step4title'),
      desc: t('upload.step4info'),
      image: step4,
    },
  ];

  return (
    <Flex w="100%" maxW="1200px" direction="column" align="center">
      <Flex w="100%" direction={isDesktop ? 'row' : 'column'} align="stretch" gap="24px">
        {steps.map((step, index) => (
          <Flex key={index} direction="column" flex="1" minW="0">
            <Flex direction="column" gap="10px" flex="1">
              <Image src={step.icon} boxSize="46px" flexShrink={0} />

              <Text
                fontFamily="Open Sans"
                fontWeight={600}
                fontSize="20px"
                lineHeight="120%"
                letterSpacing="0.01em"
                whiteSpace="nowrap"
              >
                {step.title}
              </Text>

              <Text fontFamily="Open Sans" fontWeight={400} fontSize="16px" lineHeight="150%" letterSpacing="0.01em">
                {step.desc}
              </Text>
            </Flex>

            <Flex w="100%" mt="24px" flexShrink={0} style={{ aspectRatio: '3 / 2' }}>
              <Image src={step.image} w="100%" h="100%" objectFit="contain" />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default Instruction;
